// imports
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IActionItem } from '../../common/types';

// interfaces / types / consts
interface Props { navItems?: IActionItem[] }

// exports
export function Nav(props: Props): JSX.Element {
  const { navItems } = props;
  // hooks configuration
  const navigate = useNavigate();
  // private method
  const navigateTo = (url: string): void => { if (url.includes('http')) { window.open(url); } else { navigate(url); } };

  // render
  return (
    <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div className="offcanvas-header">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      {Boolean(navItems?.length) && (
        <div className="offcanvas-body">
          <ul className="list">
            {navItems?.map((item) => (
              <button
                type="button"
                key={item.key}
                className="list-item"
                onClick={() => navigateTo(item.url || '')}
              >
                <div data-bs-dismiss="offcanvas">
                  <div className="item-text">
                    {item.key}
                  </div>
                </div>
              </button>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export function OffCanvas(props: Props): JSX.Element {
  const { navItems } = props;
  return (
    <div className="header-toggler-container">
      {Boolean(navItems?.length) && (
        <button
          type="button"
          data-bs-toggle="offcanvas"
          aria-controls="offcanvasNavbar"
          data-bs-target="#offcanvasNavbar"
        >
          <span className="toggler-icon" />
        </button>
      )}

    </div>
  );
}

// default props
Nav.defaultProps = { navItems: [] };
OffCanvas.defaultProps = { navItems: [] };
